<div class="row">
  <nb-card>
    <nb-card-header>شناسایی دوعاملی</nb-card-header>
    <nb-card-body>
      <div *ngIf="!isTwoFactorActive" class="col-12">
        <p>
          برای استفاده از این امکان، ابتدا اپ موبایل GAuthenticator را روی گوشی خود نصب نمایید.
          می‌توانید این اپ را از
          <a
            href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
            target="_blank"
          >
            گوگل پلی
          </a>
          یا
          <a
            href="https://cafebazaar.ir/app/com.google.android.apps.authenticator2/"
            target="_blank"
          >
            کافه بازار
          </a>
          یا
          <a href="https://apps.apple.com/us/app/google-authenticator/id388497605" target="_blank">
            اپل استور
          </a>
          نصب نمایید. پس از نصب این اپ، بارکد زیر را توسط اپ Google Authenticator گوشی خود اسکن
          نمایید.
        </p>
        <div class="text-center d-flex justify-content-center my-3">
          <div
            id="qrCode"
            alt="qr code"
          ></div>
        </div>
        <div class="text-center my-3 px-5">
          <nb-card class="warning">
            <nb-card-body>
              <div>
                <p class="mb-3 h6">کد بازیابی</p>
                <div class="mx-auto mb-3" style="max-width: 500px">
                  <nb-form-field class="w-100">
                    <button (click)="copyText()" nbSuffix status="primary" nbButton ghost>
                      <i class="far fa-copy fs-20"></i>
                    </button>
                    <input
                      fullWidth
                      nbInput
                      readonly
                      status="primary"
                      class="code fs-20 text-center"
                      [value]="token"
                    />
                  </nb-form-field>
                </div>
                <p class="mb-3"></p>
              </div>
              <p>
                کاربر گرامی ؛ پس از تایید کد، ورود به حساب شما علاوه بر گذرواژه نیاز به وارد کردن کد
                شناسایی دوعاملی نیز خواهد داشت. لطفا از حذف اپ Google Authenticator از گوشی خود
                خودداری کرده و حتما از بارکد بالا تصویری تهیه کنید و به صورت امن ذخیره‌سازی کنید، یا
                عبارت بالا را روی یک کاغذ نوشته و به صورت امن نگهداری نمایید تا درصورت دردسترس نبودن
                اپ Google Authenticator امکان بازیابی کد دوعاملی را داشته باشید.
              </p>
            </nb-card-body>
          </nb-card>
        </div>
        <div class="row">
          <p>
            پس از اسکن بارکد، مورد مربوط به نسواکس در اپ شما ایجاد خواهد شد. برای تایید صحت
            فرآیند، کدی که در اپ خود مشاهده می‌کنید را در کادر زیر وارد نمایید.
          </p>
        </div>
        <form (ngSubmit)="activeTfa()">
          <div class="d-flex flex-column align-items-center">
            <input
              [(ngModel)]="code"
              class="text-center auth-code"
              [status]="error['code'] === undefined ? 'basic' : 'danger'"
              nbInput
              name="code"
              type="text"
              appOnlyNumber
              appNumberLimit
              [maxDigit]="6"
              placeholder="------"
              dir="ltr"
            />
            <app-validation-error [errors]="error" name="code"></app-validation-error>
          </div>
          <div class="text-center my-3">
            <button
              [nbSpinner]="verifyCodeLoading"
              [disabled]="verifyCodeLoading"
              nbButton
              status="primary"
              class="mx-2"
            >
              ارسال کد تایید
            </button>
          </div>
        </form>
      </div>
      <div *ngIf="isTwoFactorActive" class="col-12">
        <p class="mb-0">
          شناسایی دو عاملی برای شما
          <span class="text-success">فعال</span>
          است
        </p>
      </div>
      <div *ngIf="loading" class="loading-backdrop">
        <i class="fal fa-circle-notch fa-spin fa-3x"></i>
      </div>
    </nb-card-body>
  </nb-card>
</div>
